import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=0643c198&scoped=true&"
import script from "./UserList.vue?vue&type=script&lang=js&"
export * from "./UserList.vue?vue&type=script&lang=js&"
import style0 from "./UserList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserList.vue?vue&type=style&index=1&id=0643c198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0643c198",
  null
  
)

export default component.exports